module.exports = __webpack_public_path__ + "img/device_model_off.f8ec07be.svg";